import React, { Component } from "react";
import { connect } from "react-redux";

import { setSelectedUsers } from "Actions";
import { fetchUsers } from "Thunks";
import User from "./User";
import AvatarFetching from "./AvatarFetching";
import NotFound from "NotFound/NotFound";
import _ from "i18n";

export class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      requestsTokens: [],
      loadingMore: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fetching !== this.props.fetching) {
      this.setState({
        loadingMore: nextProps.fetching
      });
    }
  }

  loadMore() {
    const { role, searchWord, dispatch } = this.props;

    if (!this.props.fetching && !this.props.usersError) {
      this.setState({
        currentPage: this.state.currentPage + 1
      });
      dispatch(fetchUsers(this.state.currentPage, searchWord, role));
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchUsers()).then(() => {
      this.setState({
        currentPage: this.state.currentPage + 1
      });
    });
  }

  componentDidUpdate(prevProps) {
    const { role, searchWord, dispatch, usersError } = this.props;
    const { currentPage } = this.state;

    if (prevProps.role !== role || prevProps.searchWord !== searchWord) {
      this.setState({
        currentPage: 0
      });

      dispatch(fetchUsers(0, searchWord, role));
    }

    const classList = document.getElementById("setting-users").classList;
    if (usersError != null && usersError.code === 404 && currentPage === 0) {
      //classList.remove('row');
      //document.getElementById('setting-users').style.padding = 0;
    } else if (!classList.contains("grid-x")) {
      //classList.add('row');
      document.getElementById("setting-users").style.padding = "4rem 0";
    }
  }

  isSelected = user => {
    const { selectedIds } = this.props;

    return selectedIds.some(id => id === user.id);
  };

  toggleSelectUser = user => {
    const { dispatch, selectedIds } = this.props;

    const { navCommunity } = this.props;
    const { mediaSettings } = navCommunity;
    const preferences = mediaSettings && mediaSettings.preferences;
    if (preferences) {
      const generalTypes = preferences.generalTypes
        ? preferences.generalTypes.split(",")
        : [];
      if (generalTypes.length === 0) return false;
    }

    if (this.isSelected(user)) {
      dispatch(setSelectedUsers(selectedIds.filter(id => id !== user.id)));
    } else {
      dispatch(setSelectedUsers([...selectedIds, user.id]));
    }
  };

  renderLoading() {
    const { loadingMore } = this.state;

    if (!loadingMore) {
      return null;
    }

    return <div className="infinite-scroll__loading">{_("Loading...")}</div>;
  }

  renderLoadMore() {
    const { loadingMore, fetching } = this.state;

    if (!loadingMore && !fetching) {
      return (
        <div className="infinite-scroll__loading">
          <a className="load-more" onClick={this.loadMore.bind(this)}>
            {_("Load more")}
          </a>
        </div>
      );
    }

    return null;
  }

  render() {
    const { fetching, users, usersError } = this.props;
    const { currentPage } = this.state;

    if (fetching && currentPage === 0) {
      return (
        <div className="setting-fetching small-8 column grid-x">
          {[...Array(8).keys()].map(i => (
            <div class="column small-12 medium-4 large-3">
              <AvatarFetching key={i} />
            </div>
          ))}
        </div>
      );
    }

    if (!users) {
      return null;
    }

    if (usersError != null && usersError.code === 404 && currentPage === 0) {
      return (
        <div className="small-8 column grid-x">
          <NotFound
            mainClass="small-12 medium-12"
            txt="No User Could Be Found"
          />
        </div>
      );
    }

    return (
      <div className="small-8 column grid-x">
        {users.map(user => (
          <div class="column small-12 medium-4 large-3">
            <User
              {...user}
              key={`user-${user.id}`}
              onSelected={this.toggleSelectUser.bind(this, user)}
              isSelected={this.isSelected(user)}
            />
          </div>
        ))}
        {this.renderLoading()}
        {this.renderLoadMore()}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  users: state.users.items,
  fetched: state.users.fetched,
  fetching: state.users.fetching,
  usersError: state.users.error,
  role: state.settings.filter.role,
  searchWord: state.settings.filter.searchWord,
  selectedIds: state.settings.selectedUsers,
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);



// WEBPACK FOOTER //
// ./src/components/Settings/Users.js